import type { CSSProperties, ReactNode } from "react"

interface PageFlowProps {
  gap?: "400" | "600" | "800"
  className?: string
  children: ReactNode
}

export const PageFlow = ({ gap, className, children }: PageFlowProps) => (
  <div className={`page-flow ${className ?? ""}`} style={gap ? ({ "--page-flow-gap": `var(--space-${gap})` } as CSSProperties) : undefined}>
    {children}
  </div>
)

export const FlowFlush = ({ children }: { children: ReactNode }) => <div className="flow-flush">{children}</div>
